import { Controller } from "@hotwired/stimulus"

// Live preview for Settings → Numbering. Mirrors DocumentNumbering#format_number
// so the owner sees the exact shape of the number before saving — the format is
// hard to picture from four separate controls, and picking the wrong one is only
// obvious once a document carries it.
//
// Period tokens come from the server as values rather than being computed here:
// the fiscal-year label depends on Pakistan's July boundary, and one definition
// of that is enough.
export default class extends Controller {
  static targets = ["output", "series", "prefix", "reset", "separator", "padding", "start"]
  static values = {
    fiscalLabel: String,   // "2026-27"
    year:        String,   // "2026"
    month:       String,   // "08"
    date:        String    // "20260829"
  }

  connect() {
    this.update()
  }

  update() {
    const start = parseInt(this.startTarget.value, 10)
    const first = Number.isFinite(start) && start > 0 ? start : 1

    this.outputTarget.textContent = this.compose(first)
    this.seriesTarget.textContent = [0, 1, 2].map((i) => this.compose(first + i)).join("   ")
  }

  compose(sequence) {
    const separator = this.separatorTarget.value
    const parts = [this.prefixTarget.value.trim(), ...this.periodParts(), this.pad(sequence)]
    return parts.filter((part) => part !== "").join(separator)
  }

  // Mirrors DocumentNumbering#period_token.
  periodParts() {
    switch (this.selectedReset()) {
      case "never":   return []
      case "yearly":  return [this.yearValue]
      case "fiscal":  return [this.fiscalLabelValue]
      case "monthly": return [this.yearValue, this.monthValue]
      case "daily":   return [this.dateValue]
      default:        return [this.yearValue]
    }
  }

  selectedReset() {
    const checked = this.resetTargets.find((input) => input.checked)
    return checked ? checked.value : "yearly"
  }

  pad(sequence) {
    const width = parseInt(this.paddingTarget.value, 10) || 4
    return String(sequence).padStart(width, "0")
  }
}
